// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:32:03.202Z
// Property: Parc At Murfreesboro (ID: 6767906449162903)
// Collections: 58 amenities, 7 floorplans (live), 53 photos, 4 POIs, 11 reviews, 6 virtual tours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162903",
  "property_external_id": "4810270",
  "property_zillow_url": "https://www.zillow.com/apartments/murfreesboro-tn/parc-at-murfreesboro/BXhSzC/",
  "property_apartments_url": "https://www.apartments.com/parc-at-murfreesboro-murfreesboro-tn/01t10r1",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "parc-at-murfreesboro",
  "property_name": "Parc At Murfreesboro",
  "property_website_url": "https://www.parcatmurfreesboro.com",
  "property_domain": null,
  "property_address": "3237 Memorial Blvd",
  "property_full_address": "3237 Memorial Blvd",
  "property_address_1": "3237 Memorial Blvd",
  "property_address_2": null,
  "property_address_city": "Murfreesboro",
  "property_address_state": "TN",
  "property_address_zip_full": "37129-5247",
  "property_address_zip": "37129",
  "property_address_country": "US",
  "property_address_county": "Rutherford County",
  "property_neighborhood_address": "Outer Rutherford County",
  "property_address_latitude": "35.9059839",
  "property_address_longitude": "-86.385414",
  "property_email": "murfreesboro@alapts.com",
  "property_phone": "(615) 686-2414",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal living space at Parc at Murfreesboro, offering one, two, and three-bedroom floor plans. Enjoy exceptional amenities, including a refreshing pool, modern fitness center, and inviting clubhouse. Find your new home today—browse our availability or schedule a tour to experience our vibrant community in beautiful Murfreesboro, Tennessee!",
  "property_long_description": "Welcome to Parc At Murfreesboro, your perfect retreat in the heart of Murfreesboro, Tennessee! Our vibrant apartment community offers a variety of spacious floor plans tailored to suit your lifestyle—choose from inviting one, two, or three-bedroom apartments designed for comfort and convenience. Each residence features modern finishes and ample natural light, creating a warm and welcoming atmosphere.\n\nAt Parc At Murfreesboro, the amenities don’t stop at your doorstep. Dive into relaxation with our luxurious swimming pool, or elevate your fitness routine at our state-of-the-art fitness center. Enjoy social gatherings in our stylish clubhouse, perfect for connecting with neighbors or hosting friends. For those pursuing work-life balance, our business center ensures you have everything you need just steps from home.\n\nOur community is designed with your needs in mind, boasting on-site maintenance and a dedicated property manager available around the clock. Experience seamless living with 24-hour access and convenient public transportation options, making your commute effortless. Plus, unwind at our media center/move theatre for movie nights with family and friends!\n\nNestled in a prime location, Parc At Murfreesboro provides a lifestyle that blends comfort with community. Explore our diverse floor plans and discover the ideal home for you. Don’t miss out on this incredible opportunity—find your new home today! Browse our availability or schedule a tour to visit our community and see all that we have to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-b303-77c5-8767-e2f67e94d366.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen island with granite countertop and stainless steel dishwasher, open to living room.",
    "public_id": "019cfddd-b303-77c5-8767-e2f67e94d366",
    "storage_key": "property/6767906449162903/019cfddd-b303-77c5-8767-e2f67e94d366.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "359",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.37883008356546",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-a7c0-74a5-ab6b-7820bb1610d9.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddd-a7c0-74a5-ab6b-7820bb1610d9",
    "storage_key": "property/6767906449162903/019cfddd-a7c0-74a5-ab6b-7820bb1610d9.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-a7c0-74a5-ab6b-7820bb1610d9.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddd-a7c0-74a5-ab6b-7820bb1610d9",
    "storage_key": "property/6767906449162903/019cfddd-a7c0-74a5-ab6b-7820bb1610d9.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "686 - 1403",
  "property_sqft_min": "686",
  "property_sqft_max": "1403",
  "property_price_range": "1394 - 2440",
  "property_price_min": "1394",
  "property_price_max": "2440",
  "property_available_units": 13,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover your perfect home at Parc At Murfreesboro with our spacious one, two, and three-bedroom floor plans. Nestled in vibrant Murfreesboro, Tennessee, our community offers easy access to local favorites and nearby attractions. Explore our neighborhood today and see why Parc At Murfreesboro is the ideal place to live!",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Welcome to Murfreesboro, a growing city that combines historic charm with modern living. Located in the heart of Tennessee, this thriving community sits just 34 miles southeast of Nashville. Home to Middle Tennessee State University's campus of over 20,000 students, the city offers diverse rental options from contemporary apartment communities to historic properties. The rental market remains steady, with current average rents around $1,300 for one-bedroom units.\n\t\t\t\t\tMurfreesboro's historic downtown square features the antebellum courthouse, anchoring the city's heritage district. Outdoor enthusiasts appreciate the Stones River Greenway system's 12 miles of paved trails and Barfield Crescent Park's 430 acres of recreational space. Cultural attractions include the Center for the Arts and the Discovery Center at Murfree Spring, featuring 20 acres of protected wetlands. Notable areas include the historic downtown district, the Gateway area, and neighborhoods near the university.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Murfreesboro",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover the perfect home at Parc At Murfreesboro, featuring spacious one, two, and three-bedroom floor plans. Enjoy our resort-style amenities, including a sparkling pool, fitness center, and media room. With on-site management and 24-hour access, your comfort is our priority. Explore our amazing community amenities today!",
  "property_applynow_blurb": "Discover your ideal living space at Parc At Murfreesboro in Tennessee. Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a pool, fitness center, and clubhouse. Apply now and find your new home—lease online today for 24-hour access to comfort and convenience!",
  "property_contactus_blurb": "Discover your perfect home at Parc At Murfreesboro! Our community offers a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments. With a welcoming atmosphere in beautiful Murfreesboro, Tennessee, we’re here to help. Have questions? Contact our leasing team today for more information!",
  "property_faqs_blurb": "At Parc At Murfreesboro, we offer a variety of floor plans, including one, two, and three-bedroom apartments to suit your lifestyle. Located in vibrant Murfreesboro, Tennessee, our community is designed for comfort and convenience. Browse our FAQs page for answers to your questions and discover your perfect home today!",
  "property_floorplans_blurb": "Discover your ideal living space at Parc At Murfreesboro in Murfreesboro, Tennessee. Explore our thoughtfully designed floor plans, featuring one, two, and three-bedroom options. With a variety of layouts to choose from, you're sure to find the perfect fit. Browse our available apartment homes today!",
  "property_gallery_blurb": "Discover your ideal home at Parc At Murfreesboro! Choose from spacious one, two, and three-bedroom floor plans featuring top-notch amenities like a pool, fitness center, and clubhouse. Picture yourself enjoying 24-hour access, a media center, and on-site maintenance. Explore our photo gallery and envision your new lifestyle today!",
  "property_interactivemap_blurb": "Discover your perfect home at Parc At Murfreesboro, offering elegant one, two, and three-bedroom floor plans. Enjoy resort-style amenities like a refreshing pool, state-of-the-art fitness center, and welcoming clubhouse. Use our interactive community map to explore available apartments, pricing, and find your ideal space in Murfreesboro, Tennessee!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "At Parc At Murfreesboro in Tennessee, we offer spacious one, two, and three-bedroom floor plans designed for your comfort. Great friends make great neighbors—refer a friend to our vibrant community today and share the joy of living in a place you love! Explore our floor plans and join us!",
  "property_residentaccess_blurb": "Welcome to Parc At Murfreesboro in Murfreesboro, Tennessee! Explore our diverse floor plans, including spacious one, two, and three-bedroom apartments. Ready to simplify your living experience? Access your resident portal now to pay rent, schedule maintenance, and much more. Enjoy seamless living at Parc At Murfreesboro!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257804052",
  "property_scheduletour_blurb": "Discover your perfect home at Parc At Murfreesboro, located in the heart of Murfreesboro, Tennessee. Explore our diverse range of floor plans, including one, two, and three-bedroom options. Ready to experience our vibrant community? Schedule a tour today and see what our residents have to say about living here!",
  "property_thankyou_blurb": "Thank you for your interest in Parc At Murfreesboro! Our community offers a variety of spacious floor plans, including one, two, and three-bedroom apartments tailored to your lifestyle. A team member will reach out shortly to assist you in finding your perfect home in beautiful Murfreesboro, Tennessee.",
  "property_virtualtours_blurb": "Discover your perfect home at Parc At Murfreesboro! Our thoughtfully designed one, two, and three-bedroom floor plans cater to your unique lifestyle. Experience the charm of Murfreesboro, Tennessee. Ready to see more? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Parc At Murfreesboro",
  "property_seo_title_home": "Parc At Murfreesboro | Apartments in Murfreesboro, Tennessee",
  "property_seo_description_home": "Discover your perfect apartment at Parc At Murfreesboro! Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, and a cozy clubhouse. With on-site maintenance and property management, plus convenient access to public transport, you'll feel right at home. Explore our media center and enjoy 24-hour access for ultimate convenience. Find your new home today in beautiful Murfreesboro, Tennessee!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Murfreesboro, Tennessee",
  "property_seo_description_floorplans": "Discover your ideal living space at Parc At Murfreesboro, where comfort meets style in the heart of Murfreesboro, Tennessee. Explore our diverse selection of one, two, and three-bedroom floor plans designed to suit your lifestyle. Browse our available apartment homes today and find the perfect floor plan that fits your needs!",
  "property_seo_title_amenities": "Amenities | Murfreesboro, Tennessee Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant living experience at Parc At Murfreesboro in Tennessee! Explore our stunning one, two, and three-bedroom floor plans, complemented by a wealth of exceptional amenities. Enjoy a refreshing dip in the pool, stay fit in our modern fitness center, or unwind in the clubhouse. With a business center, on-site maintenance, and 24-hour access, convenience is at your fingertips. Plus, enjoy easy access to public transportation and our state-of-the-art media center. Experience the perfect blend of comfort and community—explore our amazing amenities today!",
  "property_seo_title_gallery": "Gallery | Apartments in Murfreesboro, Tennessee",
  "property_seo_description_gallery": "Explore the vibrant lifestyle at Parc At Murfreesboro in Murfreesboro, TN! Browse our stunning photo gallery showcasing our chic one, two, and three-bedroom floor plans, and discover exceptional amenities like a refreshing pool, fitness center, and inviting clubhouse. Enjoy 24-hour access, on-site maintenance, and a convenient business center. Picture yourself living here—start your journey today!",
  "property_seo_title_virtualtours": "Virtual Tours | Parc At Murfreesboro Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Parc At Murfreesboro in Tennessee! Explore our spacious floor plans, featuring one, two, and three-bedroom apartments. Ready for your next adventure? Take a virtual tour today and experience the exceptional lifestyle our community has to offer!",
  "property_seo_title_interactivemap": "Interactive Map | Parc At Murfreesboro Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Parc At Murfreesboro, where modern living meets convenience in the heart of Tennessee! Explore our spacious one, two, and three-bedroom floor plans, along with top-notch amenities including a refreshing pool, state-of-the-art fitness center, and a cozy clubhouse. Enjoy 24-hour access, on-site maintenance, and public transportation nearby. Don’t miss out—use our interactive community map to search available apartments, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Murfreesboro, Tennessee",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Parc At Murfreesboro, where you can enjoy a variety of local favorites and nearby attractions. Explore our one, two, and three-bedroom floor plans that fit your lifestyle. See what’s around our community and experience the best of Murfreesboro, Tennessee!",
  "property_seo_title_contact": "Contact Us | Parc At Murfreesboro",
  "property_seo_description_contact": "Discover your perfect home at Parc At Murfreesboro, where our diverse floor plans include spacious one, two, and three-bedroom apartments designed for comfort and convenience. Nestled in the heart of Murfreesboro, Tennessee, we’re here to help you find the ideal living space. Have questions? Contact our leasing team today for personalized assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Murfreesboro, Tennessee",
  "property_seo_description_faqs": "Discover the perfect blend of comfort and convenience at Parc At Murfreesboro, your ideal apartment community in Murfreesboro, Tennessee. Whether you're seeking a cozy one-bedroom, a spacious two-bedroom, or a generous three-bedroom layout, we have a floor plan to suit your lifestyle. Enjoy top-notch amenities including a refreshing pool, a fully-equipped fitness center, a welcoming clubhouse, and a state-of-the-art media center. Our 24-hour maintenance and management teams ensure peace of mind. Have questions? Browse our FAQs page to find detailed answers and learn more about our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Murfreesboro, Tennessee",
  "property_seo_description_reviews": "Discover why residents love living at Parc At Murfreesboro! Explore our vibrant community in Murfreesboro, Tennessee, featuring spacious one, two, and three-bedroom floor plans. Enjoy top-notch amenities like a pool, fitness center, clubhouse, and a convenient business center, all with on-site management and 24-hour access. Ready to learn more? Dive into our resident reviews and see what makes Parc At Murfreesboro the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Murfreesboro, Tennessee",
  "property_seo_description_applynow": "Discover your dream apartment at Parc At Murfreesboro in Tennessee! Choose from spacious one, two, and three-bedroom floor plans designed for your lifestyle. Enjoy exclusive amenities including a refreshing pool, state-of-the-art fitness center, welcoming clubhouse, and a business center for your convenience. With on-site maintenance, 24-hour access, and easy public transportation options, your comfort is our priority. Apply now and find your new home—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Parc At Murfreesboro",
  "property_seo_description_residentaccess": "Unlock convenience at Parc At Murfreesboro! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your living experience in beautiful Murfreesboro, TN. Join our community today!",
  "property_seo_title_referafriend": "Refer A Friend | Parc At Murfreesboro",
  "property_seo_description_referafriend": "\"Spread the joy of community at Parc At Murfreesboro! Refer a friend today and help them discover their perfect home in beautiful Murfreesboro, Tennessee. Great friends make great neighbors—share the experience of luxurious living with those you care about!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Parc At Murfreesboro",
  "property_seo_description_scheduletour": "Discover your new home at Parc at Murfreesboro! Nestled in the heart of Murfreesboro, Tennessee, our vibrant apartment community offers modern living and exceptional amenities. Want to see it for yourself? Schedule a tour of our community today and experience the perfect blend of comfort and convenience!",
  "property_seo_title_privacy": "Privacy Policy | Parc At Murfreesboro",
  "property_seo_description_privacy": "Discover how Parc At Murfreesboro values your privacy! Our comprehensive Privacy Policy outlines how we protect your personal information while you enjoy your new home in beautiful Murfreesboro, Tennessee. Click to learn more about our commitment to your security. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Parc At Murfreesboro",
  "property_seo_description_accessibility": "\"Discover inclusivity at Parc At Murfreesboro! Our Accessibility Statement highlights our commitment to digital inclusion and ensuring all residents enjoy the best apartment living in Murfreesboro, Tennessee. Explore our accessible features today and join a community that values everyone!\"",
  "property_seo_title_sitemap": "Sitemap | Parc At Murfreesboro",
  "property_seo_description_sitemap": "Discover your dream home at Parc At Murfreesboro! Our sitemap offers an easy way to explore our stunning amenities, apartment layouts, and community features in the heart of Murfreesboro, Tennessee. View our website sitemap now to navigate your path to luxury living!",
  "property_seo_title_thankyou": "Thank You | Parc At Murfreesboro",
  "property_seo_description_thankyou": "Thank you for your interest in Parc At Murfreesboro! Our team is excited to connect with you about your new apartment home in beautiful Murfreesboro, Tennessee. Expect a personalized response soon as we help you find the perfect space to call home.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1784584424942",
  "amenities": [
    {
      "id": "ec_b0ba14bc5787e3f1f2fcd665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9a16dd6e0f77ef9568f490b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc4b65b0c6e198976fd947da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c86e8b320043fd95dda2471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8164fbe164061bc600e0cad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d36fa4649f0a4eeb57aa0e69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ede8f9ef34971aa17a8a0b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8cc22c2afdc32a8ce5398fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fa2501657e16eb38c2b8df9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d33fa73446eecbb3611b0a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ce1d510ce606208198fe238",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56520fa3943a2fd18c896b12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "*In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ded957e5a4c819cc46e51201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "1st Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ed4e4b2cfc57566414c686a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "2 Outdoor Firepits",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72e57695e3d7236d81674b72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "9` Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf0333d335d76a42d0334abb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "ADA",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fabd86802f20d24b682abcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Amenity View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd7e8c51388c92c83740080c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ab35c32f7b4222a485f10c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Amp Fitness",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4427c287c44418454d5de670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Bark Park for your Furry Friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_183d3f7ec75c6acd06ebcf78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Shelving*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac2da1a5b79023bd71f08742",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Common Area WiFi Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a45853bb976b594873ae61e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Car Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f04a989566ab2e48ada51aff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Gaming Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c38ce1ec147fed3b461616f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6eb0f01f44f58a03c86a8dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Decorative Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58c779cc79d80a053278f257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Deep Kitchen Sinks w/ Gooseneck Faucets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8969e3b2517f1765577b0f33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d376331fc90a76bdc5c27f9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Gourmet Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d95a08893e16ace3f6e23917",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer and Dryers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c15ae8468067c919f9bfc83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Interactive Fitness Classes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f61d39879e6fe327021afb14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen Pantry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a74a04c277c2f06e034cd230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Gaming Including Bocce Ball & Cornhole",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7dc3b3954e305aea7e95697b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Outdoor Grilling Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cf1a9acba9c193f79f6a784",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Parcel Pending Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3bc327c947c395a741bf87e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2db8f4149e39b2e475d6a9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool view",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b03ab1ca3916970d94840156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios and Balconies*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5539d146e11ac2dcf7679746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebc996b64527dcd45b0a978b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Smart Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f3e4ef4d421b397480955cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunrooms*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5184932d76e146168e2aef33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Top Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ac74a5cd219c0ae5f4ccce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_541949fd88ce83b64bf5d721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7ffc9a1583388a3dbd140c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b0c179db2b16a116030809c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63ab060161aedaebecc89aca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbb075e24118e31c7c0c89d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_679fbd95d8496f2fbf682556",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_024cff3f5ee96120609353f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cff959c38c2effd2e7966a5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99160cd535d87b769294ffec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1d4f626cf8a72e14af20a18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b359c32bfea825be2a1a635c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43c51f74536a61a2de73345e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81685f5c122f3aec19ecbd8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5888c5604e0bdc49669d715",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_848f554fde3476a8b4ebc964",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "external_id": "false",
      "title": "Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_02818974a8312466201627b7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-c9a9-7458-9926-daafead96141.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertops and sink, open to living room with seating area and TV.",
        "public_id": "019cfddc-c9a9-7458-9926-daafead96141",
        "storage_key": "property/6767906449162903/019cfddc-c9a9-7458-9926-daafead96141.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "A spacious and modern open-concept living area featuring a sleek kitchen island, comfortable seating, and large windows for natural light.",
      "link": "false",
      "alt_text": "Modern kitchen island with granite countertops and sink, open to living room with seating area and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k_LkJ1mk3m5i15QpVryv9erWIRLGDcDls6efBAXrhQg/102/image.jpg"
    },
    {
      "id": "ec_1fafae7182539fc57eae8785",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-c9a9-7458-9926-daafead96141.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertops and sink, open to living room with seating area and TV.",
        "public_id": "019cfddc-c9a9-7458-9926-daafead96141",
        "storage_key": "property/6767906449162903/019cfddc-c9a9-7458-9926-daafead96141.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "A spacious and modern open-concept living area featuring a sleek kitchen island, comfortable seating, and large windows for natural light.",
      "link": "false",
      "alt_text": "Modern kitchen island with granite countertops and sink, open to living room with seating area and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/k_LkJ1mk3m5i15QpVryv9erWIRLGDcDls6efBAXrhQg/102/image.jpg"
    },
    {
      "id": "ec_eade490eb1d4e26162669676",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-cad7-73b8-9358-331abd75e426.webp",
      "image_media": {
        "alt_text": "Community lounge with seating, bar, pool table, and shuffleboard.",
        "public_id": "019cfddc-cad7-73b8-9358-331abd75e426",
        "storage_key": "property/6767906449162903/019cfddc-cad7-73b8-9358-331abd75e426.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Relax and socialize in our modern community lounge, featuring comfortable seating, a fully equipped bar, pool table, and shuffleboard for endless entertainment.",
      "link": "false",
      "alt_text": "Community lounge with seating, bar, pool table, and shuffleboard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SjDIwrsBK1I5bXAiumHLVNvh8ZrQSXT8ts_FxzBPxWQ/110/image.jpg"
    },
    {
      "id": "ec_d9b28140476fce12f2ee9195",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-c9e9-759a-b32a-a76b37ece9af.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with weight machines, treadmills, and a dumbbell rack.",
        "public_id": "019cfddc-c9e9-759a-b32a-a76b37ece9af",
        "storage_key": "property/6767906449162903/019cfddc-c9e9-759a-b32a-a76b37ece9af.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Our fully equipped fitness center features modern cardio and strength training equipment to help you stay active and healthy.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with weight machines, treadmills, and a dumbbell rack.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rMYFJCHCGWdIefZwK_vYnXztZz2JCvGYMZAOHJNig60/102/image.jpg"
    },
    {
      "id": "ec_339509e2b33b048a5293b66f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-cb60-743e-bff9-6c62155c3909.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with a long wooden table and chairs, overlooking a swimming pool and apartment buildings.",
        "public_id": "019cfddc-cb60-743e-bff9-6c62155c3909",
        "storage_key": "property/6767906449162903/019cfddc-cb60-743e-bff9-6c62155c3909.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and relaxation by the pool. This community offers comfortable outdoor seating areas perfect for gathering with friends and family.",
      "link": "false",
      "alt_text": "Outdoor dining area with a long wooden table and chairs, overlooking a swimming pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZnzajzOTAzAhKvoxolV1qDqk4ufWvjJgOAQODSs46m8/110/image.jpg"
    },
    {
      "id": "ec_03881411a7f0eab710715bf2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-d7d8-766c-b001-f2c0a69cd45f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
        "public_id": "019cfddc-d7d8-766c-b001-f2c0a69cd45f",
        "storage_key": "property/6767906449162903/019cfddc-d7d8-766c-b001-f2c0a69cd45f.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large granite island, stainless steel appliances, and ample cabinet space, opening to a bright living area.",
      "link": "false",
      "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Mq-JuPLQAnDXefyxMP7bFaqJS_PQqJg51HMQGdDMKAM/102/image.jpg"
    },
    {
      "id": "ec_ce562ce60672a5e99960311b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-d5eb-7251-a967-1606ea9ae224.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in a modern apartment with white cabinets, stainless steel appliances, and hardwood floors.",
        "public_id": "019cfddc-d5eb-7251-a967-1606ea9ae224",
        "storage_key": "property/6767906449162903/019cfddc-d5eb-7251-a967-1606ea9ae224.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious living room and open-concept kitchen featuring white cabinetry, stainless steel appliances, and elegant hardwood flooring, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Living room and kitchen area in a modern apartment with white cabinets, stainless steel appliances, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2EkhZwjjAYr6OCByxyLzxdGrrlMfNnStMWVYxOBANWw/102/image.jpg"
    },
    {
      "id": "ec_886b0b392b9f61e75ac0585d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-d6d9-752a-8fd0-531a8a1623d9.webp",
      "image_media": {
        "alt_text": "Modern open-concept living and kitchen area with granite island and stainless steel appliances.",
        "public_id": "019cfddc-d6d9-752a-8fd0-531a8a1623d9",
        "storage_key": "property/6767906449162903/019cfddc-d6d9-752a-8fd0-531a8a1623d9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience stylish open-concept living with a modern kitchen featuring a granite island and stainless steel appliances, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern open-concept living and kitchen area with granite island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/engNRLRrSpJq0WRZKrnPOzZMkbNODCtH6c0s8F3qg7U/102/image.jpg"
    },
    {
      "id": "ec_a70d6e4476390c7b383be5a6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-da75-73c6-b28d-948163f05c4e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a sofa, armchair, coffee table, and stainless steel appliances.",
        "public_id": "019cfddc-da75-73c6-b28d-948163f05c4e",
        "storage_key": "property/6767906449162903/019cfddc-da75-73c6-b28d-948163f05c4e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable sofa, elegant armchair, and a fully equipped kitchen with stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a sofa, armchair, coffee table, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NMwyw-AWogk2lxwo4p5Q6BLkYHAxKp3cf3xAiKuF89A/119/image.jpg"
    },
    {
      "id": "ec_cca8c987cff1cdb87b9b55b9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-e0a4-7258-ae39-416136832e0f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, and a doorway to a bathroom.",
        "public_id": "019cfddc-e0a4-7258-ae39-416136832e0f",
        "storage_key": "property/6767906449162903/019cfddc-e0a4-7258-ae39-416136832e0f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a comfortable queen-sized bed, stylish nightstands with task lamps, and tasteful artwork. A glimpse into the en-suite bathroom adds to the appeal.",
      "link": "false",
      "alt_text": "Bedroom with a queen-sized bed, nightstands, and a doorway to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TGKumAVzTGWBy8laQYwcemPbwTZLpKpUBJS85rYJauY/102/image.jpg"
    },
    {
      "id": "ec_786877dd821bb30cc660a311",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-e59e-702d-be08-2f6522720fb4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and a view into the bedroom.",
        "public_id": "019cfddc-e59e-702d-be08-2f6522720fb4",
        "storage_key": "property/6767906449162903/019cfddc-e59e-702d-be08-2f6522720fb4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite-top vanity, ample cabinet storage, and a bathtub with white subway tile surround. A glimpse into the adjacent bedroom is visible through the open doorway.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, toilet, and a view into the bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FhbU0105IGMFhpDIg_hs5sYB4j-uxMiju7DH6yLTlsg/119/image.jpg"
    },
    {
      "id": "ec_69b26d5d62516aba74b40dbd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-e454-7620-899a-e564a42c13a0.webp",
      "image_media": {
        "alt_text": "Empty closet with shelving and a guitar",
        "public_id": "019cfddc-e454-7620-899a-e564a42c13a0",
        "storage_key": "property/6767906449162903/019cfddc-e454-7620-899a-e564a42c13a0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious closet with shelving and ample storage space, perfect for organizing your belongings. A guitar leans against the wall, adding a touch of personality.",
      "link": "false",
      "alt_text": "Empty closet with shelving and a guitar",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EyF_EGbSYwHs6V7j0cByghgNfdMsEhXVCMU9mviTxHo/102/image.jpg"
    },
    {
      "id": "ec_2f1b0e87cbb7e64207c56dfd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-e94c-709e-81fb-7ff520aea0e0.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, white bedding, and decorative pillows.",
        "public_id": "019cfddc-e94c-709e-81fb-7ff520aea0e0",
        "storage_key": "property/6767906449162903/019cfddc-e94c-709e-81fb-7ff520aea0e0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a plush queen-size bed and elegant decor, creating a serene retreat.",
      "link": "false",
      "alt_text": "Primary bedroom with a queen-size bed, white bedding, and decorative pillows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZHqrX4Zpv0L57xEilepAnYGs47COks8pTLjBIaq1w4c/119/image.jpg"
    },
    {
      "id": "ec_31e436be20905122bc594d3a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-eefd-74d1-99ca-e89ba8ac41f9.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with walk-in closet and separate shower.",
        "public_id": "019cfddc-eefd-74d1-99ca-e89ba8ac41f9",
        "storage_key": "property/6767906449162903/019cfddc-eefd-74d1-99ca-e89ba8ac41f9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Luxurious double vanity bathroom featuring a spacious walk-in closet with a plush robe and a sleek glass-enclosed shower, perfect for unwinding.",
      "link": "false",
      "alt_text": "Double vanity bathroom with walk-in closet and separate shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CsY5B7Tk_8mvcqVl0uhnqDCJa5JfTLfpLViR0a2xXoU/102/image.jpg"
    },
    {
      "id": "ec_f91ee9c9183a41bd403004a1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-ef91-72dd-bf29-62302464ded5.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelves, a white robe, and a vintage suitcase.",
        "public_id": "019cfddc-ef91-72dd-bf29-62302464ded5",
        "storage_key": "property/6767906449162903/019cfddc-ef91-72dd-bf29-62302464ded5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving, a plush white robe, and a charming vintage suitcase, perfect for storing your belongings.",
      "link": "false",
      "alt_text": "Walk-in closet with shelves, a white robe, and a vintage suitcase.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zEVLHw_pqipwMz3J5F-3LbyV1raePvU0Kc9EouRGq6o/119/image.jpg"
    },
    {
      "id": "ec_0fd44f666f2fb85495ddbe69",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-f15a-767a-8bb4-709b6062eda6.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a laundry closet.",
        "public_id": "019cfddc-f15a-767a-8bb4-709b6062eda6",
        "storage_key": "property/6767906449162903/019cfddc-f15a-767a-8bb4-709b6062eda6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access.",
      "link": "false",
      "alt_text": "Stackable washer and dryer in a laundry closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rU8fKk8NHMG8yysLysE-yKxPwGXOG1egaKaQa7AnZR4/102/image.jpg"
    },
    {
      "id": "ec_ee606909daf8cffcb3045b18",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-f644-719c-bb98-1cee52eb0b9f.webp",
      "image_media": {
        "alt_text": "Balcony with seating area and table overlooking parking lot",
        "public_id": "019cfddc-f644-719c-bb98-1cee52eb0b9f",
        "storage_key": "property/6767906449162903/019cfddc-f644-719c-bb98-1cee52eb0b9f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, furnished with comfortable seating and a small table. This outdoor space offers a tranquil retreat with a view of the surrounding landscape.",
      "link": "false",
      "alt_text": "Balcony with seating area and table overlooking parking lot",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yssmT2zCbxjSU5OMs3dzQYLADX0CgLKfBBDTfC3WPDE/102/image.jpg"
    },
    {
      "id": "ec_d7d5c76be3b1a03ef78782a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-fe7e-7666-9ae5-42887b55c50c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, tables, and apartment buildings in the background.",
        "public_id": "019cfddc-fe7e-7666-9ae5-42887b55c50c",
        "storage_key": "property/6767906449162903/019cfddc-fe7e-7666-9ae5-42887b55c50c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient seating areas. Our community amenities offer the perfect space to unwind and entertain.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs, tables, and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3Q6WDe_q_RPo0LdUYv1UKPsFn_DVqjhDhb66ldHZ0Bs/102/image.jpg"
    },
    {
      "id": "ec_7dab01c7b6032012916cc798",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-fb7e-7263-b190-37905c7e0d7b.webp",
      "image_media": {
        "alt_text": "King bed with white linens and decorative pillows in a bedroom with a bench at the foot of the bed.",
        "public_id": "019cfddc-fb7e-7263-b190-37905c7e0d7b",
        "storage_key": "property/6767906449162903/019cfddc-fb7e-7263-b190-37905c7e0d7b.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this spacious bedroom, featuring a luxurious king-size bed and elegant decor, perfect for relaxation.",
      "link": "false",
      "alt_text": "King bed with white linens and decorative pillows in a bedroom with a bench at the foot of the bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CtsZk8t8qePkSazBRN8vMXUjWIdXD568UDU5gTQd-Dc/119/image.jpg"
    },
    {
      "id": "ec_d0a2f4ffbc789beeac4978a2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-fb7e-7263-b190-30b1f9c9768a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop vanity, toilet, and a walk-in closet.",
        "public_id": "019cfddc-fb7e-7263-b190-30b1f9c9768a",
        "storage_key": "property/6767906449162903/019cfddc-fb7e-7263-b190-30b1f9c9768a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek granite countertop vanity, a convenient toilet, and a walk-in closet for ample storage.",
      "link": "false",
      "alt_text": "Modern bathroom with a granite countertop vanity, toilet, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TJX1EMuwE31ZQCJOvewqZ4ZKH5Tp5a1IstUCj-_ilnY/102/image.jpg"
    },
    {
      "id": "ec_507fe15a854e712a0b01779b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-00d6-70b0-9bf7-4b032a6f2328.webp",
      "image_media": {
        "alt_text": "Gym with exercise bikes, weights, and fitness equipment",
        "public_id": "019cfddd-00d6-70b0-9bf7-4b032a6f2328",
        "storage_key": "property/6767906449162903/019cfddd-00d6-70b0-9bf7-4b032a6f2328.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, free weights, and a dedicated space for strength training. Stay active and healthy without leaving home.",
      "link": "false",
      "alt_text": "Gym with exercise bikes, weights, and fitness equipment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1vr2MvCuX7dwdF2BbeSpENmyTTp9qEMXtgOctfqamIY/119/image.jpg"
    },
    {
      "id": "ec_8e10eb139de763ace1700586",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-07e7-70ca-99ea-2901e0840bea.webp",
      "image_media": {
        "alt_text": "Spacious living room with a brown leather couch, coffee table, and large windows.",
        "public_id": "019cfddd-07e7-70ca-99ea-2901e0840bea",
        "storage_key": "property/6767906449162903/019cfddd-07e7-70ca-99ea-2901e0840bea.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Cozy and stylish living room featuring a comfortable leather sofa, a decorative rug, and ample natural light from large windows. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a brown leather couch, coffee table, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_KEJmso3DyX9pnKMz1aRYWvVIXO-1e35p08fJVipNSw/102/image.jpg"
    },
    {
      "id": "ec_09b28e9c2269441b95fbc0e0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-0acb-742d-bfe5-e04781f70aa1.webp",
      "image_media": {
        "alt_text": "Bar area with counter and stools in a community lounge.",
        "public_id": "019cfddd-0acb-742d-bfe5-e04781f70aa1",
        "storage_key": "property/6767906449162903/019cfddd-0acb-742d-bfe5-e04781f70aa1.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a modern bar area with comfortable seating.",
      "link": "false",
      "alt_text": "Bar area with counter and stools in a community lounge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qoPJ0g_Vs1n0QcK6nyShVI8NnOxAHe93-hBZI3kHTPM/119/image.jpg"
    },
    {
      "id": "ec_0ac18634d4e79a2ce88d0084",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-0bdb-751d-b5f3-a18d9915d1fe.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, soaking tub, walk-in shower, and walk-in closet.",
        "public_id": "019cfddd-0bdb-751d-b5f3-a18d9915d1fe",
        "storage_key": "property/6767906449162903/019cfddd-0bdb-751d-b5f3-a18d9915d1fe.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Indulge in the spa-like experience of this luxurious bathroom, complete with a double vanity, deep soaking tub, walk-in shower, and spacious walk-in closet.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, soaking tub, walk-in shower, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vAWL76H_dtf38VhADphR1a6ps6awoXPidqzERAc1xx0/102/image.jpg"
    },
    {
      "id": "ec_7683b4a9badefd0aaf75a049",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-0a99-73f8-93bc-c6a356a00250.webp",
      "image_media": {
        "alt_text": "Outdoor cabana with chaise lounge chairs by a swimming pool at a multifamily property.",
        "public_id": "019cfddd-0a99-73f8-93bc-c6a356a00250",
        "storage_key": "property/6767906449162903/019cfddd-0a99-73f8-93bc-c6a356a00250.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax in style under the cabana, featuring comfortable chaise lounge chairs and a serene poolside atmosphere, perfect for unwinding.",
      "link": "false",
      "alt_text": "Outdoor cabana with chaise lounge chairs by a swimming pool at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/D906kgd-DzTkZZAe6mRIKl5AYSF84RtbKJYKRheuu40/119/image.jpg"
    },
    {
      "id": "ec_d6527dafd7d1020ff1cccbf3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-163e-7019-bfcc-a420310ce80e.webp",
      "image_media": {
        "alt_text": "Comfortable seating area on a screened-in porch with views of the apartment buildings and courtyard.",
        "public_id": "019cfddd-163e-7019-bfcc-a420310ce80e",
        "storage_key": "property/6767906449162903/019cfddd-163e-7019-bfcc-a420310ce80e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed screened-in porch, offering a serene escape with comfortable seating and picturesque views of the community amenities and apartment exteriors.",
      "link": "false",
      "alt_text": "Comfortable seating area on a screened-in porch with views of the apartment buildings and courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cCOoTDRjlSfOR3bOY53oqPjvTLQV3001_oBFoR3b5sA/102/image.jpg"
    },
    {
      "id": "ec_1fec612c04b8534ad26b7fb9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-1b0c-76f5-8869-48ae5b2ecc9b.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, closet, and en-suite bathroom.",
        "public_id": "019cfddd-1b0c-76f5-8869-48ae5b2ecc9b",
        "storage_key": "property/6767906449162903/019cfddd-1b0c-76f5-8869-48ae5b2ecc9b.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space, and an adjoining bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a bed, closet, and en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7tbSKnuIs2d3M3n42Nbjm1-dqBMTqfTOkJk611cKmIc/119/image.jpg"
    },
    {
      "id": "ec_bf7e084b45210a20b0adbacf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-1987-7478-b6d2-1804bb8ad05a.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings and a clubhouse.",
        "public_id": "019cfddd-1987-7478-b6d2-1804bb8ad05a",
        "storage_key": "property/6767906449162903/019cfddd-1987-7478-b6d2-1804bb8ad05a.webp",
        "width": 2000,
        "height": 1124
      },
      "title": "Community",
      "description": "Enjoy our resort-style outdoor swimming pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge chairs and shaded areas, it's an oasis in our vibrant community.",
      "link": "false",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings and a clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Yr94oxwldlI57K0EuEkcxZ9V3rdGad1LmZunT10zUbY/102/image.jpg"
    },
    {
      "id": "ec_c024a5ac0974ecb6084be1e0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-1c26-7579-a04e-d68741b1c293.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets",
        "public_id": "019cfddd-1c26-7579-a04e-d68741b1c293",
        "storage_key": "property/6767906449162903/019cfddd-1c26-7579-a04e-d68741b1c293.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uRW7UZsowDfQVMIEH9EwddVYF-iVe-yxmgBWhZi8Fiw/119/image.jpg"
    },
    {
      "id": "ec_f4f889e3dfc89ba9890e6b66",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e81-e9da-76ca-9675-8700f35726a6.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with gray siding and stone accents.",
        "public_id": "019d4e81-e9da-76ca-9675-8700f35726a6",
        "storage_key": "property/6767906449162903/019d4e81-e9da-76ca-9675-8700f35726a6.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Showcasing the exterior architecture of the apartment building, featuring its modern design with stone and siding finishes.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with gray siding and stone accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/roo93tJJi7bM7WX3VdKqRQFh3Xh7qQwpb3CknCH45O8/102/image.jpg"
    },
    {
      "id": "ec_263f8a4d1e4b3068d920b0e4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-2773-734e-a27c-7d13d8d4fd20.webp",
      "image_media": {
        "alt_text": "Living room with couch, coffee table, TV, and decorative items. Features artwork and large windows.",
        "public_id": "019cfddd-2773-734e-a27c-7d13d8d4fd20",
        "storage_key": "property/6767906449162903/019cfddd-2773-734e-a27c-7d13d8d4fd20.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Cozy living room showcasing a comfortable sofa, a stylish coffee table, and a wall-mounted TV, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with couch, coffee table, TV, and decorative items. Features artwork and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VtLLwJd66jVMa0s2E_L8W3wQTTVbi441zPHbMBYLD1Q/119/image.jpg"
    },
    {
      "id": "ec_d51485be1c4afe54bfae1b4f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-28b3-766e-9c3d-958dbe0c5c3a.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with a large sectional sofa and armchairs in a communal lounge.",
        "public_id": "019cfddd-28b3-766e-9c3d-958dbe0c5c3a",
        "storage_key": "property/6767906449162903/019cfddd-28b3-766e-9c3d-958dbe0c5c3a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge, featuring plush seating and a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Comfortable seating area with a large sectional sofa and armchairs in a communal lounge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/i7PdVMwshWt0YkGfq4Jl72LSe-rysZ1ySnHJI2K_2ZQ/102/image.jpg"
    },
    {
      "id": "ec_bc1d0868aad3d748cb37945f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-28e0-740d-b2e8-774170a818d6.webp",
      "image_media": {
        "alt_text": "Bright and airy open-concept living space with kitchen island, dining area, and living room.",
        "public_id": "019cfddd-28e0-740d-b2e8-774170a818d6",
        "storage_key": "property/6767906449162903/019cfddd-28e0-740d-b2e8-774170a818d6.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience modern living in this spacious open-concept apartment, featuring a gourmet kitchen with granite countertops, a cozy dining nook, and a comfortable living area.",
      "link": "false",
      "alt_text": "Bright and airy open-concept living space with kitchen island, dining area, and living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hEhoG___hPW8zzrOYUX0SI2nQ3pkfOuOTk-uUF6HwRE/119/image.jpg"
    },
    {
      "id": "ec_6b1a050c8e40122a4760ee8a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-30b9-713f-be3e-a874ea49cf5e.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fireplace and modern chairs.",
        "public_id": "019cfddd-30b9-713f-be3e-a874ea49cf5e",
        "storage_key": "property/6767906449162903/019cfddd-30b9-713f-be3e-a874ea49cf5e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating and a beautiful stone fireplace, perfect for gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "Outdoor seating area with fireplace and modern chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/-EDhWXM4u15AyxzMunbXWjl54wW4XIYcYQjDLWjDxRY/102/image.jpg"
    },
    {
      "id": "ec_9b0dafe468f01165cc060bd0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-3493-72ae-8fc9-b8b2090c8ce2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shelving. Bedroom visible through doorway.",
        "public_id": "019cfddd-3493-72ae-8fc9-b8b2090c8ce2",
        "storage_key": "property/6767906449162903/019cfddd-3493-72ae-8fc9-b8b2090c8ce2.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek vanity, a modern toilet, and ample shelving for storage. A glimpse of the comfortable bedroom adds to the appeal.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and shelving. Bedroom visible through doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/zMUpJsQasVMQLkOX2oLd5DKsHwG2E_jjqIj0rKlfLlk/119/image.jpg"
    },
    {
      "id": "ec_736484e133df2fcba1a63657",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-007b-7659-8ba0-fd8a9024d228.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills and ellipticals overlooking the community.",
        "public_id": "019d4e82-007b-7659-8ba0-fd8a9024d228",
        "storage_key": "property/6767906449162903/019d4e82-007b-7659-8ba0-fd8a9024d228.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring cardio machines and free weights. Enjoy your workout with scenic views of the community.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with treadmills and ellipticals overlooking the community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tkdcM1VMQhJaKUDcGm1VMWCh-bTtZP6EpV3JPFFECIg/102/image.jpg"
    },
    {
      "id": "ec_012ac95335378548964e2064",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-3a14-7764-a081-9b80c691cd9a.webp",
      "image_media": {
        "alt_text": "Chalkboard wall with photos and grocery list, next to open shelving in apartment living area.",
        "public_id": "019cfddd-3a14-7764-a081-9b80c691cd9a",
        "storage_key": "property/6767906449162903/019cfddd-3a14-7764-a081-9b80c691cd9a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish apartment interior features a large chalkboard wall with personal notes and photos, complemented by open shelving displaying decor and kitchenware.",
      "link": "false",
      "alt_text": "Chalkboard wall with photos and grocery list, next to open shelving in apartment living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KTRBFccyo7UVAp6ifqb36MLncBO9LcK8lIdwyy7cyeQ/119/image.jpg"
    },
    {
      "id": "ec_a5fa0f5913d131a2168c363d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-1212-758d-9807-77a8d317c80b.webp",
      "image_media": {
        "alt_text": "Pool table with balls and cues in a lounge area with bar seating and a TV.",
        "public_id": "019d4e82-1212-758d-9807-77a8d317c80b",
        "storage_key": "property/6767906449162903/019d4e82-1212-758d-9807-77a8d317c80b.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a game of pool in our stylish resident lounge, complete with a full bar and entertainment area.",
      "link": "false",
      "alt_text": "Pool table with balls and cues in a lounge area with bar seating and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/D2uJpzI_LDeAz6-kK3gPgtV-DKLn-V81bfwthpEjv3Y/102/image.jpg"
    },
    {
      "id": "ec_e384f9df98274e29f9923422",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-448e-702c-ad83-829df10a288e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019cfddd-448e-702c-ad83-829df10a288e",
        "storage_key": "property/6767906449162903/019cfddd-448e-702c-ad83-829df10a288e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in our beautifully appointed kitchens, featuring sleek granite countertops and modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lTqQl3PrU4TvTwxnku9HCNARFZxJg7LDj783NijIUbo/119/image.jpg"
    },
    {
      "id": "ec_d26d71849d50568fec62e672",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-36ae-771a-b4eb-5e68c4ff24cc.webp",
      "image_media": {
        "alt_text": "Apartment complex with a swimming pool and lounge chairs.",
        "public_id": "019d4e82-36ae-771a-b4eb-5e68c4ff24cc",
        "storage_key": "property/6767906449162903/019d4e82-36ae-771a-b4eb-5e68c4ff24cc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and an outdoor fireplace for cooler evenings. Perfect for relaxation and socializing.",
      "link": "false",
      "alt_text": "Apartment complex with a swimming pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7CvqFHCrQCDtqP16RB0H8jLzIZQ1UKBmTRjh_1YQAyk/102/image.jpg"
    },
    {
      "id": "ec_2ba998ac959b2e18426f8846",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-4a88-718c-9fd5-8d946719004f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, patterned accent wall, and large windows with blinds.",
        "public_id": "019cfddd-4a88-718c-9fd5-8d946719004f",
        "storage_key": "property/6767906449162903/019cfddd-4a88-718c-9fd5-8d946719004f.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, stylish accent wall, and ample natural light from large windows.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, patterned accent wall, and large windows with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LPTG3kInq8rz-WRVTjeL6rH6-g6zY_QxLmdrSYcyQWc/119/image.jpg"
    },
    {
      "id": "ec_575256467d36f1d5ab5e7c5b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-2705-7089-9cf7-f58ca0b258c4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with modern lounge chairs and a clubhouse in the background.",
        "public_id": "019d4e82-2705-7089-9cf7-f58ca0b258c4",
        "storage_key": "property/6767906449162903/019d4e82-2705-7089-9cf7-f58ca0b258c4.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy our beautiful resort-style swimming pool, featuring comfortable lounge chairs and a stunning clubhouse for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with modern lounge chairs and a clubhouse in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rZ5lYKP2CrqBwxsbE5VbJCcFRTu9hlGu87kFckX7ZpA/104/image.jpg"
    },
    {
      "id": "ec_8664b21715c00e6efb3e2288",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-4f2e-72f9-b4f6-04acddfa07ca.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving, baskets, and a white bathrobe hanging.",
        "public_id": "019cfddd-4f2e-72f9-b4f6-04acddfa07ca",
        "storage_key": "property/6767906449162903/019cfddd-4f2e-72f9-b4f6-04acddfa07ca.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving, decorative baskets, and a plush white bathrobe, offering a touch of luxury and organization.",
      "link": "false",
      "alt_text": "Walk-in closet with shelving, baskets, and a white bathrobe hanging.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QlHdb0taZHbl6uHYHw5kz1Aluybnph-YWUD2ARltbF0/119/image.jpg"
    },
    {
      "id": "ec_ee174a71a1277dcf4360b68b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-42f6-707a-bfb8-84f5fb0bd9e6.webp",
      "image_media": {
        "alt_text": "Modern lobby with a reception desk, comfortable seating, and artistic wall decor.",
        "public_id": "019d4e82-42f6-707a-bfb8-84f5fb0bd9e6",
        "storage_key": "property/6767906449162903/019d4e82-42f6-707a-bfb8-84f5fb0bd9e6.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Welcome to our stylish community lobby, featuring a contemporary reception desk, plush seating areas, and a unique textured accent wall. Perfect for relaxation and socializing.",
      "link": "false",
      "alt_text": "Modern lobby with a reception desk, comfortable seating, and artistic wall decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EEySlLO5-4lkiwqKw9_2nVKZyNKwwOlnKk5dEO6FgYY/104/image.jpg"
    },
    {
      "id": "ec_1a1c73616f4a2ff0a0e3874b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-5739-7439-a59c-cc2ea81b31fe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel appliances, and open-concept living area.",
        "public_id": "019cfddd-5739-7439-a59c-cc2ea81b31fe",
        "storage_key": "property/6767906449162903/019cfddd-5739-7439-a59c-cc2ea81b31fe.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed kitchen featuring a large granite island, sleek cabinetry, and stainless steel appliances, seamlessly flowing into the living space.",
      "link": "false",
      "alt_text": "Modern kitchen with granite island, stainless steel appliances, and open-concept living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/J1SxQjfoMPGclBmzPcRFC3OmhiZLI2WvqNbCcgT77pM/119/image.jpg"
    },
    {
      "id": "ec_230bda903ff8028270e251bb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-5a4b-7235-8e16-d28fbb154a10.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with multiple floors and balconies.",
        "public_id": "019cfddd-5a4b-7235-8e16-d28fbb154a10",
        "storage_key": "property/6767906449162903/019cfddd-5a4b-7235-8e16-d28fbb154a10.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stunning exterior view of our apartment building, showcasing its modern design, multiple floors, and private balconies, set against a clear blue sky.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with multiple floors and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_h9PadYTnfTdJWzWXfZJG2JjL1bZJ5FxawQ4S_U_X7I/102/image.jpg"
    },
    {
      "id": "ec_d412e218bfdf2e78a3c7c586",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-5b3c-75c0-8245-6be36fd74d51.webp",
      "image_media": {
        "alt_text": "A modern community amenity area features a stainless steel coffee maker, wine fridge, and a decorative horse statue.",
        "public_id": "019cfddd-5b3c-75c0-8245-6be36fd74d51",
        "storage_key": "property/6767906449162903/019cfddd-5b3c-75c0-8245-6be36fd74d51.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy fresh coffee from our state-of-the-art coffee maker, complemented by a selection of snacks and beverages, all within our stylish community lounge.",
      "link": "false",
      "alt_text": "A modern community amenity area features a stainless steel coffee maker, wine fridge, and a decorative horse statue.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KdbAfPxOxhlzN3YpehlU6iAQD3g6mpkgNOUuj-ZuQEM/119/image.jpg"
    },
    {
      "id": "ec_1c91cc73b974a8507cbcd345",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-4de3-73cd-b134-f9ff3967fd17.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush seating, decorative artwork, and large windows.",
        "public_id": "019d4e82-4de3-73cd-b134-f9ff3967fd17",
        "storage_key": "property/6767906449162903/019d4e82-4de3-73cd-b134-f9ff3967fd17.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and contemporary decor.",
      "link": "false",
      "alt_text": "Modern lounge area with plush seating, decorative artwork, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/M9sRauGG-XmIuIDOtqxt_B3J-pISGgUZH8_EJa-EHG8/102/image.jpg"
    },
    {
      "id": "ec_e5bed55b667e068024f3af46",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-6781-717b-9c1d-cd6a89c69137.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grills, counter space, and TV.",
        "public_id": "019cfddd-6781-717b-9c1d-cd6a89c69137",
        "storage_key": "property/6767906449162903/019cfddd-6781-717b-9c1d-cd6a89c69137.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy cooking and entertaining outdoors at our community's full-service outdoor kitchen, complete with grills and a television.",
      "link": "false",
      "alt_text": "Outdoor kitchen with grills, counter space, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZEhQXq1ux_8Ijpv4drhFKXfvgYeDurhEGlO3mlPGYrI/119/image.jpg"
    },
    {
      "id": "ec_d3a41615f41dd99dbf9dc6fd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-547c-738d-9a05-19aadc5f463d.webp",
      "image_media": {
        "alt_text": "Modern clubhouse lounge with wood table, blue chairs, and large windows.",
        "public_id": "019d4e82-547c-738d-9a05-19aadc5f463d",
        "storage_key": "property/6767906449162903/019d4e82-547c-738d-9a05-19aadc5f463d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed clubhouse lounge, featuring comfortable seating, stylish decor, and ample space for community gatherings.",
      "link": "false",
      "alt_text": "Modern clubhouse lounge with wood table, blue chairs, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/p9-PoLDBURrHtAAbfR5JXV1ZELY06qy6EjJni4fAyw8/102/image.jpg"
    },
    {
      "id": "ec_5039be0f1ee8dcbca39dde34",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-4bd9-73f8-9352-78bb370e93c3.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with modern furnishings.",
        "public_id": "019d4e82-4bd9-73f8-9352-78bb370e93c3",
        "storage_key": "property/6767906449162903/019d4e82-4bd9-73f8-9352-78bb370e93c3.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Apartment",
      "description": "Spacious living and dining area flowing into a modern kitchen with stainless steel appliances and granite countertops.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment with modern furnishings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NZ8mwne9dMrSJvPftgh_noLG5YQbpgHvTae-_EVukVY/102/image.jpg"
    },
    {
      "id": "ec_a3834d4aa0b97fdecbd93629",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-6c26-7732-956d-1936433ce3eb.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building's leasing office with a \"Now Open\" banner.",
        "public_id": "019cfddd-6c26-7732-956d-1936433ce3eb",
        "storage_key": "property/6767906449162903/019cfddd-6c26-7732-956d-1936433ce3eb.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Welcome to our newly opened leasing office! Come tour your future home today.",
      "link": "false",
      "alt_text": "Exterior view of the apartment building's leasing office with a \"Now Open\" banner.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/U19tHQIU0-HUT9CL3o5YPM9eks1e_3IVAc9TN-Y2qd8/119/image.jpg"
    },
    {
      "id": "ec_b2e215a78a4c8225e42a7054",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-6233-715e-83a3-bce6cb85c603.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings, a swimming pool, and lush landscaping.",
        "public_id": "019d4e82-6233-715e-83a3-bce6cb85c603",
        "storage_key": "property/6767906449162903/019d4e82-6233-715e-83a3-bce6cb85c603.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Discover luxury living at our expansive apartment community, featuring a sparkling pool, modern amenities, and beautifully designed buildings set amidst green surroundings.",
      "link": "false",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings, a swimming pool, and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/n0BkQwxhv_1Ea66g3jIeU4dkoOxMi1atgai5haG8KMU/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_7175165d62e215600ca8ccc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "poi_name": "Northfield Elementary",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a2d10689e257ce67d23362be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "poi_name": "Siegel Middle School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_cee6f483d096f0c8d6992e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "poi_name": "Siegel High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_62e188afbcd750443ab5b85f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "poi_name": "Providence Christian Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_4e94b2e4c537cae4c8c401c2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "Besides all sorts of shopping options within blocks, I love the superb styling and finishes.  Can't overlook the fact that my apartment is brand new. One bedroom (large). Love the gray cabinets (lots of them), hardwood floors, and stainless-steel appliances. Island. Plenty of room in the master closet which includes a larger size stackable washer & dryer. Very comfortable and quiet. Last, but not least, the staff is super friendly and helpful!",
      "date": "false",
      "title": "Superb Styling & Shopping Convenience"
    },
    {
      "id": "ec_9688398d9012216770670c07",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "To be honest, I don't understand how people can expect a community that is still growing to be completely silent and for the greenery to be self maintained. For the price of living and the amenities provided, this place is a beauty. How or why someone would be complaining is beyond me. It is not the administrations fault for any of it. As a common worker in the surrounding area I knew what I was coming into and what to expect until all construction was finished! These people are doing their best and have been doing a magnificent job to provide what us residents currently have. Rules which unfortunately get broken by younger individuals that think a \"whoopsie\" is easily forgiven just because they are still/fresh out of college. It takes a mature mind to understand that nothing gets maintained at 100% quietness. Beauty does NOT happen on it's own without work being put into it. Parc at Murfreesboro is gorgeous from a distance and up close. I wouldn't change ANYTHING as I know the conditions are getting better as the weeks pass. Tyler, Holly and company have been a dream to deal with and sure did make us feel at home. If you're looking to rent here, jump on it because you do not want to miss out. A pet friendly, relaxation haven awaits. If you already live here, feel blessed. The Parc is where it's at. ",
      "date": "false",
      "title": "All that and then some."
    },
    {
      "id": "ec_fd840eeb133a5bbdb2e539b8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "4",
      "name": "false",
      "text": "Anna is the new community manager at the Parc at Murfreesboro and she really took good care of me without going into details. We have renewed our lease for another 6 months, due to our house still being built. Love the new management, but hate my neighbors. I would've given a 5 star rating, but the apartments aren't insulated well at all. ",
      "date": "false",
      "title": "New Community Manager is Awesome"
    },
    {
      "id": "ec_6cdcc6a2928ccae01235151c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "We have been living here for two months and I love it, yes there is construction but it goes on when I am at work so it doesn’t bother me. I love the area too!  They are very accommodating and helpful, Haley is the best consultant. She is so nice and helpful and is just so sweet! ",
      "date": "false",
      "title": "Love it! "
    },
    {
      "id": "ec_b4379dc8c48a3fefcefbe372",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "This place is UNMATCHED! I had such a seamless move in process and here are my highlights! \n- no hidden fees, this was big for me because I feel like a lot of places sell you on a price and when you move in your face planted with extra fees everywhere. \n- you get what you pay for, and I mean this in a positive way. I know everything is so expensive nowadays but at least here, the price makes sense with everything the community has! \n- the staff is truly amazing. Everyone has been so friendly and inviting and honestly you don’t get that much anymore. \nSo so happy to call Parc home!! ",
      "date": "false",
      "title": "I would definitely recommend! "
    },
    {
      "id": "ec_9f248c210752073b5fb5b485",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "I just got approved here recently and I have to say it has been so seamless! They walked me through everything and were very transparent so I always knew exactly what to expect. Everyone was so helpful and made it an easy decision. The property alone is beautiful and I loved the built in shelving that's available in some of the units. Excited to move in soon!",
      "date": "false",
      "title": "So helpful and informative!"
    },
    {
      "id": "ec_00526f52cad8032caa32928e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "Truly an incredible complex run by even more impressive staff. Maintenance is always on top of their game even with the crazy southern weather we experience, and even when things break or go out of service their communication and dedication to finding solutions rapidly is always appreciated. Caty, Lena, Niki and of course Alanah are always so pleasant and professional every time I come to the office. Aaron, Zach, and Dawson do a phenomenal job and show dignity and respect to everyone. I love living here, not just for the beautiful amenities but the beautiful people that keep Parc the BEST!",
      "date": "false",
      "title": "Love living here!"
    },
    {
      "id": "ec_5f4602985ed54323666f756b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "Lena has been an absolute pleasure to work with throughout the entire application process. She answers all of my questions, no how matter how small. She's been a huge part in making me feel at ease, when moving is, let's face it - stressful. I don't move in until next spring but I am very much looking forward to calling this beautiful property my next home. Thank you Lena for ALL of your assistance! ",
      "date": "false",
      "title": "Beautiful property - Seamless Application Process "
    },
    {
      "id": "ec_d595dd4437edf01982dd01b4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "I moved here in October 2024, and I have yet to see any bugs, had any maintenance issues, or have any issues with residents/ staff. Everything is very nice, and I’m not worried about safety here!",
      "date": "false",
      "title": "Property is very nice and friendly"
    },
    {
      "id": "ec_8d827db57369700f9a3b74e3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "5",
      "name": "false",
      "text": "I rented at a brand new apartment complex when I lived in Florida, and I thought they were the standard… until I got to Parc at Murfreesboro.  \nMany times, a leasing office is there to get you to sign the lease and then they are done with you.  NOT HERE.  They wave, they smile, they respond to texts and messages, and even if it isn’t their area of responsibility, they help anyway.  The management and maintenance staff are the friendliest and most responsive I’ve ever worked with.  The complex is clean- and at any given time of day you’ll see maintenance staff puttering around the complex, always being proactive.\nFinally, the community is quiet.  I just love living here.  If you’re undecided between Parc and another apartment complex, pick Parc.  You won’t be disappointed.",
      "date": "false",
      "title": "Friendly, clean, responsive, quiet"
    },
    {
      "id": "ec_fb5bb7dbb2690663a5373f60",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "rating": "4",
      "name": "false",
      "text": "Lived here for 3 years and I loved it! But I also needed to rent a storage unit because the 1 bedroom apartments are just too small. Biggest issue was cost of lease renewal. It was high. Over 3 years it went up 30%. I was sad to leave but I couldn't justify the cost. The manager and staff are top notch!! ",
      "date": "false",
      "title": "Loved Living Here"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_105e581b7a330a877d6a236e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Parc at Murfreesboro",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/2b1s8g?source=180"
    },
    {
      "id": "ec_78867d61b1397faf26a22a8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-97d6-711d-8b60-165a3e2348b4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious communal lounge with seating areas, a bar, a pool table, and a shuffleboard table.",
        "public_id": "019cfddd-97d6-711d-8b60-165a3e2348b4",
        "storage_key": "property/6767906449162903/019cfddd-97d6-711d-8b60-165a3e2348b4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SrC61M1N2Dh"
    },
    {
      "id": "ec_f352399063c52b2d7ab675cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-c9e9-759a-b32a-a76b37ece9af.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "State-of-the-art fitness center with weight machines, treadmills, and a dumbbell rack.",
        "public_id": "019cfddc-c9e9-759a-b32a-a76b37ece9af",
        "storage_key": "property/6767906449162903/019cfddc-c9e9-759a-b32a-a76b37ece9af.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=otapwZsCxU2"
    },
    {
      "id": "ec_e8801ca480c25d3aa551cb4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-97d6-711d-8b60-10f675f3eee9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Outdoor dining area with a long wooden table and chairs, overlooking a swimming pool and apartment buildings.",
        "public_id": "019cfddd-97d6-711d-8b60-10f675f3eee9",
        "storage_key": "property/6767906449162903/019cfddd-97d6-711d-8b60-10f675f3eee9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Outdoor Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4F48Jq5TpUj"
    },
    {
      "id": "ec_d1d10ccee462f5c46af88579",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-97a4-71de-892f-acae63daa241.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a leather couch, coffee table, and entertainment center.",
        "public_id": "019cfddd-97a4-71de-892f-acae63daa241",
        "storage_key": "property/6767906449162903/019cfddd-97a4-71de-892f-acae63daa241.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Olympic Sunroom - 833SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dfqaXeJD75y"
    },
    {
      "id": "ec_b8910709add3821c60b0acbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162903",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-99d3-71a1-a088-d0cdc253bb8b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and framed art.",
        "public_id": "019cfddd-99d3-71a1-a088-d0cdc253bb8b",
        "storage_key": "property/6767906449162903/019cfddd-99d3-71a1-a088-d0cdc253bb8b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Shenandoah - 1,209SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5XkrS1257Jq"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_text_field",
      "type": "STRING",
      "value": "GTM-P3TMZM2K"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    }
  ],
  "custom_text_field": "GTM-P3TMZM2K",
  "custom_rollout_phase": "Phase 1"
};

export const generatedAt = '2026-10-05T18:32:03.202Z';
